import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import webservice from '../../../../Service/webservice';
import { AesDecrypt, AesEncrypt, keyPromise } from '../../../../Service/crypto';
import api from '../../../../api';

interface Document {
  
  firstName: string;
  lastName: string;
  emailId: string;
  UserName: string;
  user_type: string;
  
}

interface GetDataParams {
  Id?:string;
  UserType?:string;
  Role?:string;
  q?: string;
  perPage?: number;
  page?: number;
  status?: string | null;
  sort?: string;
  sortColumn?: keyof Document; // Updated to keyof Document
}

interface GetDataResponse {
  params: GetDataParams;
  q?: string;
  perPage?: number;
  page?: number;
  status?: string | null;
  sort?: string;
  data: Document[];
  allData: Document[];
  totalPages: number;
  no_Data: string | [];
  sortColumn?: keyof Document;
}



const paginateArray = (array: Document[], perPage: number, page: number): Document[] =>
  array.slice((page - 1) * perPage, page * perPage);

export const getData = createAsyncThunk<GetDataResponse, GetDataParams>(
  'AppMenu/getData',
  async (params) => {
    // const Id = UserType === 'Client' ? localStorage.getItem("ClientId") : localStorage.getItem("id");

    const Id = localStorage.id || '';
    const UserType = localStorage.UserType;
    // const Id = UserType === 'MOS' ? localStorage.id : localStorage.VendorId;
    let dataParams: Record<string, any> = {};

    const { q = '', perPage = 10, page = 1, sort, sortColumn } = params;

    dataParams['UserType'] = UserType;
    dataParams['UserID'] = Id;
    dataParams['perPage'] = perPage;
    dataParams['page'] = page;
    dataParams['sort'] = sort;
    dataParams['sortColumn'] = sortColumn;
    dataParams['q'] = q;
    const key = await keyPromise
    // Convert dataParams to a JSON string before encryption
    const dataParamsString = JSON.stringify(dataParams);
    const EncParams = await AesEncrypt(key,dataParamsString);

    try {
      const response = await api.fetch('api/usermanagement/Getuser', {
        method: 'POST',
        body: JSON.stringify({ EncParams })
      });
      const key = await keyPromise
      const jsonResponse = await response.json();
      const Response = await AesDecrypt(key,jsonResponse)
      const Decryptdata = Response.response_data
      // const res = Response.response_data;
  
    
      if (Decryptdata.length === 0 || Decryptdata === 'There is no Record Found') {
        return {
          params,
          data: [],
          allData: [],
          totalPages: 0,
          no_Data: 'There is no Record Found',
        };
      } else {
        const totalCount = Response.count;
        const res = Response.response_data;
        
        // res.sort((a: any, b: any) => new Date(b.created_date).getTime() - new Date(a.created_date).getTime());

        return {
          params,
          data: res.length <= perPage ? res : paginateArray(res, perPage, page),
          allData: res,
          totalPages: totalCount,
          no_Data: [],
        };
      }
    } catch (err) {
      console.error(err);
      throw err;
    }
  }
)


export const Get_permission = createAsyncThunk(
  'Usermanagement/Get_permission',
  async (data: any, { dispatch, getState }) => {
    const response = await api.fetch('api/Get_permission', {
      method: 'POST',
      body: JSON.stringify({ data })
    }).then((response) => response.json());
    return response;
  }
);


interface UserManagementState {
  data: Document[];
  total: number;
  params: GetDataParams;
  allData: Document[];
  no_Data: string | [];
}

const initialState: UserManagementState = {
  data: [],
  total: 0,
  params: {},
  allData: [],
  no_Data: '',
};

export const UserManagementSlice = createSlice({
  name: 'UserManagement',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getData.fulfilled, (state, action: PayloadAction<GetDataResponse>) => {
      state.data = action.payload.data;
      state.allData = action.payload.allData;
      state.total = action.payload.totalPages;
      state.params = action.payload.params;
      state.no_Data = action.payload.no_Data;
    });
  },
});

export default UserManagementSlice.reducer;
